import { func } from 'prop-types';

export const modalTypes = {
  openModal: func,
  closeModal: func
};

export const toastTypes = {
  showToast: func
};
